import { makeStyles } from '@material-ui/core';
import { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';

interface Props  extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>  {

}

const useStyles = makeStyles((theme: any) => ({
    container: {
        width: '100%',
        marginTop: 10,
        border: '0.5px solid #666666 !important',
        borderRadius: 4,
        color: '#666666',
        padding: 5,
        minHeight: '2.2rem',
    },
}));


export const TextArea: React.FC<Props> = ({...props}) => {
    const classes = useStyles();

    return ( 
        <textarea className={classes.container} {...props} />
    );
}